import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { components } from "../../../services/api/resourceEvents/types";
import { ResourceHistory } from "./index";

type Props = {
  resource: components["schemas"]["IEventResource"];
  title: string;
} & WSModalCustomProps<void>;

const ModalResourceDrillDownHistory: React.FC<Props> = props => (
  <WSModal
    title={props.title}
    onClose={props.onClose}
    size="M"
    actions={{
      alignment: "fill",
      buttons: [
        { label: "Done", kind: "Tertiary", onClick: () => props.onClose() }
      ]
    }}
  >
    <WSText.ParagraphSm color="gray500" mb="XL">
      Here's the full item history:
    </WSText.ParagraphSm>
    <ResourceHistory resources={[props.resource]} bare />
  </WSModal>
);

export const useModalResourceDrillDownHistory = () =>
  useWSModalCustom(ModalResourceDrillDownHistory);
